import { MaterialCommunityIcons } from "@expo/vector-icons";

type IconName = keyof typeof MaterialCommunityIcons.glyphMap;

export const operatorUnicodeMap: Record<string, { symbol: string; label: string; icon?: IconName }> = {
  eq: { symbol: "=", label: "equals", icon: "equal" },
  neq: { symbol: "≠", label: "not equals", icon: "not-equal-variant" },
  gt: { symbol: ">", label: "greater than", icon: "greater-than" },
  gte: { symbol: "≥", label: "greater than or equal to", icon: "greater-than-or-equal" },
  lt: { symbol: "<", label: "less than", icon: "less-than" },
  lte: { symbol: "≤", label: "less than or equal to", icon: "less-than-or-equal" },
  // like: { symbol: "~", label: "like or contains", icon: "contain" },
  like: { symbol: "~", label: "like or contains", icon: "tilde" },
  in: { symbol: "∈", label: "is any of", icon: "set-center" },
  nin: { symbol: "∉", label: "is none of", icon: "set-none" },
};
